import React, { useState } from 'react';
import useForm from './hooks/useForm';
import useValidate from './hooks/useValidate';
import {createBrowserRouter,RouterProvider} from 'react-router-dom';
import Home from './components/home';
import Login from './components/login';
import Register from './components/register';



const router = createBrowserRouter([
  {path:'/home',element:<Home/>},
  {path:'/login',element:<Login/>},
  {path:'/register',element:<Register/>},



])
function App() {
  // const { values, handleChange, handleSubmit } = useForm(
  //   {
  //     firstName: '',
  //     lastName: '',
  //     email: '',
  //   },
  //   (formValues) => {
  //     console.log('Form submitted with values:', formValues);
  //   }
  // );

  // const {error, value, changeHandler,submitHandler} = useValidate();
  // console.log(error);

  return (
    <RouterProvider router={router}/>
  );
}

export default App;

